// size: 'sm' || 'md' || 'lg'
const getImgSrcWithPrefix = (src, size) => {
  const prefix = size ? `${size}_` : '';
  const result = src?.split('/');
  if (Array.isArray(result)) {
    result[result?.length - 1] = `${prefix}${result?.[result?.length - 1]}`;
    return result.join('/');
  }
  return '';
};

export default getImgSrcWithPrefix;
